module.exports = __webpack_public_path__ + "static/media/ic_新增.796b6ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_新增.svg
// module id = 344
// module chunks = 0